module.exports = __webpack_public_path__ + "static/media/zcdt_Xi@2x.c271ec1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/zcdt_Xi@2x.png
// module id = 1886
// module chunks = 0 1